import React, { useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import { LoadingScreen } from "../../app/LoadingScreen";
import { PATHS } from "../../app/paths";

/**
 * `/cadastro` — link "Começar grátis" vindo da landing (letsdoc.ai).
 * Idêntico a `/` (PreLogin) exceto por forçar a tela de criação de conta do
 * Auth0 (`screen_hint: "signup"`) em vez da tela de login.
 */
export const SignupRedirect: React.FC = () => {
  const { isAuthenticated, loginWithRedirect, isLoading } = useAuth0();
  const navigate = useNavigate();

  useEffect(() => {
    if (isLoading) return;

    if (!isAuthenticated) {
      loginWithRedirect({
        authorizationParams: {
          audience: "https://dev-yudz81r54mtavkzj.us.auth0.com/api/v2/",
          scope: "read:current_user",
          screen_hint: "signup",
        },
      });
    } else {
      navigate(PATHS.authCallback, { replace: true });
    }
  }, [isAuthenticated, isLoading, loginWithRedirect, navigate]);

  return <LoadingScreen />;
};
